import { IEmployeeSummary } from './Employee'

export interface ICalendarStatistic {
  tableReservationPercentage: number
  homeOfficeReservationPercentage: number
  allReservationPercentage: number
  unoccupiedDaysPercentage: number
  otherLocationTableReservationPercentage: number
}

export interface ICalendarDoctorReservation {
  id: number
  healthServiceDoctorId: number
  name: string
  surname: string
  title: string
  specialty: string
  fullName: string
  reservationStartHour: string
  reservationStartHourStr: string
  reservationEndHour: string
  reservationEndHourStr: string
  planType: number
  doctorExplanation: string
  locationName: string
  blockName: string
  floorName: string
}

export interface ICalendarCoiffeurReservation {
  blockName: string
  coiffeurId: number
  floorName: string
  fullName: string
  id: number
  locationName: string
  name: string
  planType: number
  reservationEndHour: string
  reservationEndHourStr: string
  reservationStartHour: string
  reservationStartHourStr: string
  surname: string
}

export interface ICalendarGymSalonReservation {
  id: number
  gymSaloonId: number
  gymSaloonName: string
  reservationStartHour: string
  reservationStartHourStr: string
  reservationEndHour: string
  reservationEndHourStr: string
  planType: number
  locationName: string
  blockName: string
  floorName: string
}

export interface ICalendarGymGroupReservation {
  id: number
  gymSaloonId: number
  gymGroupLessonId: number
  gymSaloonName: string
  gymLessonTypeName: string
  reservationStartHour: string
  reservationStartHourStr: string
  reservationEndHour: string
  reservationEndHourStr: string
  planType: number
  locationName: string
  blockName: string
  floorName: string
}
export interface ICalendarGymTrainerReservation {
  id: number
  gymSaloonId: number
  gymSaloonName: string
  gymTrainerId: number
  gymTrainerName: string
  gymTrainerSurname: string
  gymTrainerFullName: string
  reservationStartHour: string
  reservationStartHourStr: string
  reservationEndHour: string
  reservationEndHourStr: string
  planType: number
  locationName: string
  blockName: string
  floorName: string
}

export interface ICalendarLactationReservation {
  id: number
  lactationRoomId: number
  lactationRoomName: string
  reservationStartHour: string
  reservationStartHourStr: string
  reservationEndHour: string
  reservationEndHourStr: string
  planType: number
  locationName: string
  blockName: string
  floorName: string
}
export interface ICalendarParkAreaReservation {
  id: number
  reservationStartHour: string
  reservationStartHourStr: string
  reservationEndHour: string
  reservationEndHourStr: string
  planType: number
  locationId: number
  locationName: string
  parkAreaId: number
  parkAreaName: string
  plate: string
}

export interface ICalendarMeetingReservation {
  id: number
  meetingRoomId: number
  meetingRoomName: string
  capacity: number
  reservationStartHour: string
  reservationStartHourStr: string
  reservationEndHour: string
  reservationEndHourStr: string
  planType: number
  locationId: number
  locationName: string
  blockName: string
  floorName: string
}

export interface ICalendarPoolVehicleReservation {
  id: number
  locationId: number
  locationName: string
  planType: number
  poolVehicleId: number
  poolVehiclePlate: string
  reservationEndHour: string
  reservationEndHourStr: string
  reservationStartHour: string
  reservationStartHourStr: string
  poolVehicleBrand: string
  poolVehicleModel: string
  locationToReceive: string
  locationToDeliver: string
  gearTypeName: string
  gearTypeId: number
  fuelTypeName: string
  fuelTypeId: number
  description: string
}

export interface ICalendarLeaveReservation {
  id: number
  employeeId: number
  sicilNo: string
  email: string
  startTime: string
  endTime: string
  type: number
}

export interface ICalendarMedicalCertificateReservation {
  id: number
  employeeId: number
  sicilNo: string
  email: string
  startTime: string
  endTime: string
  type: number
}

export interface ICalendarPlan {
  id: number
  tableNum: string
  floorName: string
  blockName: string
  locationId: number
  locationName: string
  locationFirmName: string
  districtName: string
  cityName: string
  countryName: string
  reservationDate: Date
  description: string
  remoteOfficeType: string
  planType: number
  enabled: boolean
  reservationDateStr: string
  dayOffDate: Date
  dayOffName: string
  dayOffIsReservable: boolean
  dayOffDateStr: string
  doctorReservation: ICalendarDoctorReservation[]
  coiffeurReservation: ICalendarCoiffeurReservation[]
  gymSaloonReservation: ICalendarGymSalonReservation[]
  gymGroupLessonReservation: ICalendarGymGroupReservation[]
  gymTrainerReservation: ICalendarGymTrainerReservation[]
  lactationReservation: ICalendarLactationReservation[]
  parkAreaReservation: ICalendarParkAreaReservation[]
  meetingRoomReservation: ICalendarMeetingReservation[]
  poolVehicleReservation: ICalendarPoolVehicleReservation[]
  leave: ICalendarLeaveReservation[]
  medicalCertificate: ICalendarMedicalCertificateReservation[]
  dayOffNameEn: string
  dayOffNameTr: string
  descriptionDayOffEn: string
  descriptionDayOffTr: string
  reservationStatusId: number
}

export enum VisiblePlan {
  NEW_PLAN = 0,
  HOME_PLAN,
  OFFICE_PLAN,
  COMMON_PLAN,
  SQUADS_PLAN,
  MULTIPLE_PLAN,
}

export enum ViewSideBar {
  CREATE = 0,
  VIEW,
  EDIT,
  CANCEL,
  MULTIPLE,
}

export interface ISideBarModel {
  day: any
  event: ICalendarPlan
  planType: VisiblePlan
  view: ViewSideBar
  user: IEmployeeSummary
}
